/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
require('./include/home-carousel')
require('./include/corona-modal')
require('./include/partners-carousel')
require('smoothscroll-polyfill').polyfill()

// window.Vue = require('vue')

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import ProductsPage from './components/ProductsPage.vue'
import Favorites from './components/Favorites.vue'
import SingleProductFavorite from './components/SingleProductFavorite.vue'
import store from './store'
import * as Cookies from 'js-cookie'
import Vue from 'vue'
window.Vue = Vue

const app = new Vue({
  el: '#app',
  components: {
    ProductsPage,
    Favorites,
    SingleProductFavorite
  },
  data() {
    return { state: store.state }
  },
  methods: {
    setFavoriteProductsFromCookies() {
      let favoritesCookie = Cookies.getJSON('favorite_products')
      if (favoritesCookie
        && favoritesCookie !== 'undefined'
        && favoritesCookie !== undefined
        && favoritesCookie instanceof Array) {
        store.setFavoriteProducts(favoritesCookie)
      } else {
        store.setFavoriteProducts([])
      }
    },
    addToFavorites(productId) {
      // transform the parent state into an ES6 Set
      let favProducts = new Set(store.getFavoriteProducts())

      if (favProducts.size) {
        // there is already something in favorites
        if (favProducts.has(productId)) {
          // we have to DE-favorite the clicked product
          favProducts.delete(productId)
        } else {
          // add the current product to favorites array
          favProducts.add(productId)
        }
      } else {
        // favorites empty, just add product id
        favProducts.add(productId)
      }
      // apply state on the parent component
      store.setFavoriteProducts(Array.from(favProducts))
    }
  },
  watch: {
    'state.favoriteProducts': {
      deep: true,
      handler() {
        Cookies.set('favorite_products', store.getFavoriteProducts())
      }
    }
  },
  mounted() {
    this.setFavoriteProductsFromCookies()
  }
})
